export default __webpack_public_path__ + "static/media/2017.027b0882.png";